import { useState } from 'react'
import { ObjectBrowseField } from './ObjectBrowseField'
import { OrgUnitPickerModal, type OrgUnitPickValue } from './OrgUnitPickerModal'

type Props = {
  value?: OrgUnitPickValue | null
  onChange?: (value: OrgUnitPickValue | null) => void
  disabled?: boolean
  className?: string
}

export function OrgUnitBrowseField({ value, onChange, disabled, className }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <ObjectBrowseField
        name={value?.name}
        placeholder="请选择部门"
        disabled={disabled}
        ariaLabel="选择部门"
        className={className}
        onBrowse={() => setOpen(true)}
      />
      <OrgUnitPickerModal
        open={open}
        value={value}
        onCancel={() => setOpen(false)}
        onConfirm={(next) => {
          onChange?.(next)
          setOpen(false)
        }}
      />
    </>
  )
}

export type { OrgUnitPickValue }
